import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M4.5 6.388c0-1.426 1.529-2.33 2.778-1.643l11.541 6.347c1.295.713 1.296 2.574 0 3.287L7.28 20.725c-1.25.688-2.779-.216-2.779-1.642zM6 19.083c0 .285.306.465.556.328l11.54-6.347a.375.375 0 0 0 0-.657L6.557 6.059A.375.375 0 0 0 6 6.39z"
}));
const ForwardRef = forwardRef(SvgComponent);
export const PlayIcon = ForwardRef;